import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {Consts} from "../pages/consts";
import {getInputFocusStyle} from "../pages/utils";

const OtherSymptomInput = ({ symptomsList, onAddNewSymptomParam }) => {
  const { t } = useTranslation();
  const [symptomTerm, setSymptomTerm] = useState("");
  const [isTextFieldFocused, setIsTextFieldFocused] = useState(false);

  const handleInputChange = (event) => {
    setSymptomTerm(event.target.value);
  };

  const handleAddSymptom = () => {
    if (symptomTerm.trim() !== "") {
      const newSymptom = {
        term: symptomTerm,
      };
      onAddNewSymptomParam(newSymptom);
      setSymptomTerm("");
    }
  };

  const isTermInList = symptomsList?.some(
    (symptom) => symptom?.term === symptomTerm?.trim(),
  );

  return (
    <div className="w3-row w3-padding-small">
      <div className="w3-col s4 w3-mobile">
        <label htmlFor="symptomInput">{t("new_health_complaints")}:</label>
      </div>
      <div className="w3-col s6 w3-mobile">
        <input
          type={Consts.TEXT}
          id="symptomInput"
          value={symptomTerm}
          onFocus={() => setIsTextFieldFocused(true)}
          onBlur={() => setIsTextFieldFocused(false)}
          onChange={handleInputChange}
          className="form-input"
          style={getInputFocusStyle(isTextFieldFocused)}
        />
      </div>
      <div className="w3-col s2 w3-mobile w3-padding-small">
        <button
          onClick={handleAddSymptom}
          className="w3-btn w3-round-xlarge w3-theme-d5"
          disabled={symptomTerm.trim() === "" || isTermInList}
        >
          {t("add")}
        </button>
      </div>
    </div>
  );
};

export default OtherSymptomInput;
